/**
 * The Dintiko mark and name, in one place.
 *
 * The tile is the app icon itself rather than a redrawn SVG, so the thing in
 * the header is byte-for-byte the thing on the home screen and in the TikTok
 * authorisation dialog. Redrawing it would drift the moment either side was
 * nudged.
 *
 * It does not follow the theme, and should not: the tile is black with a green
 * dot in both themes, the same way an installed app icon is.
 */
export function Wordmark({ size = 22 }: { size?: number }) {
  return (
    <span className="inline-flex items-center gap-2">
      <img
        src="/icons/icon-192.png"
        alt=""
        width={size}
        height={size}
        className="shrink-0 rounded-[22%]"
        style={{ width: size, height: size }}
      />
      <span className="font-display text-lg leading-none font-normal tracking-[-0.01em] text-ink">
        dintiko
      </span>
    </span>
  );
}
